import * as React from 'react';
import { Diagnostic } from '../types/diagnostic';
import { CustomMenuItemOption } from '../../../shared/components/dropdown/CustomMenuItemOption';
import { CustomMenuButton } from '../../../shared/components/dropdown/CustomMenuButton';
import { Box, Menu, MenuList, MenuOptionGroup } from '@cdl/heartbeat-react';

interface Props {
  selected: Diagnostic | null;
  list: Diagnostic[];
  handleChange: (diagnosticId: number) => void;
}
export const DiagnosticDropdown: React.FC<Props> = ({
  selected,
  list,
  handleChange,
}) => {
  if (list.length === 0 || list == null || selected == null) {
    return <></>;
  }

  return (
    <Box>
      <Menu matchWidth>
        <CustomMenuButton
          expertName={selected.expertName}
          data-testid='diagnoses-dropdown'
        />
        <MenuList maxWidth='unset'>
          <MenuOptionGroup
            type='radio'
            onChange={(v) => handleChange(parseInt(v as string))}
            value={`${selected?.id}`}
          >
            {list.map(({ expertName, updatedAt, pipeline, id }) => (
              <CustomMenuItemOption
                expertName={expertName}
                updatedAt={updatedAt}
                immutable={pipeline === 'immutable'}
                key={id}
                value={`${id}`}
              />
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};
